import { FC } from 'react';
import cx from 'classnames';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';

import { SvgIcon } from '@/components';

import styles from './TopNavLink.module.sass';

interface TopNavLinkProps {
  iconName?: string;
  text: string;
  to: string;
}

const TopNavLink: FC<TopNavLinkProps> = ({ iconName, text, to }) => {
  const resolved = useResolvedPath(to);
  const matched = useMatch({ path: resolved.pathname });

  const classes = cx(styles.link, {
    [styles['is-active']]: matched,
  });

  return (
    <Link className={classes} to={to}>
      {iconName && <SvgIcon name={iconName} className={styles.icon} />}
      <span className={styles.text}>{text}</span>
    </Link>
  );
};

export default TopNavLink;
